import { createApp, createSSRApp } from "vue"
import App from "./App.vue"
import { createRouter } from "./router"
import { createPinia } from "pinia"
import { createHead } from "@unhead/vue/client"
import firebaseFuctionInit,{ firebaseUtils } from "@/utils/analytic/firebaseUtils.js"
import vue3GoogleLogin from "vue3-google-login"
import i18n from "./i18n/i18n.js"
import fc from "@/components/functionComp/index"
import "@/assets/css/css.js"
import useUserDataStore from "@/store/userDataStore"
import * as Sentry from "@sentry/vue";
import { $$language, $$t } from "@/i18n/i18n.js"
import tools, { isDev, isMobileDevice } from "@/utils/tools.js"


export function makeApp(cookie) {
  const app = import.meta.env.SSR ? createSSRApp(App) : createApp(App)
  const router = createRouter()
  router.beforeEach((to, from, next) => {
    to.meta.from = from.fullPath
    if (to.path !== "/" && to.path.endsWith("/")) {
      next({
        path: to.path.replace(/\/+$/, ""),
        query: to.query,
        hash: to.hash,
        replace: true, // 表示替换当前 history 记录，类似 301
      })
    } else {
      next()
    }
  })

  const store = createPinia()
  const head = createHead()

  app.use(firebaseFuctionInit)
  app.use(store)
  app.use(head)
  app.use(router)
  app.use(i18n)
  app.use(fc)
  app.use(vue3GoogleLogin, {
    clientId: "1069642802272-0ktgtg6hn72ljht0bltd9h14qseflsvj.apps.googleusercontent.com",
    scope: "profile email",
  })

  // SSR 场景下初始化 userDataStore 并传递 cookie
  const userDataStore = useUserDataStore()
  if (import.meta.env.SSR) {
    userDataStore.ininCookie(cookie || "")
  }

  const getSentryUrl = () => {
    let url = ""
    const language = $$language()
    if (isDev()) {
      if (language === "en") {
        url = "https://bb094092630245787fc6089de08dcb8b@sen-as.yinhe.top/7"
      } else {
        url = "https://806b960185aa65ce7d18071d56a0b739@sen-bj.yinhe.top/4"
      }
    } else {
      if (language === "en") {
        url = "https://6f7e9f113eab81487483f81773c1b9be@sen-as.yinhe.top/6"
      } else {
        url = "https://5e44e697fcf7373ca96a120cd99761e2@sen-bj.yinhe.top/2"
      }
    }
    return url
  }

  const setSentryUid = async () => {
    const u_id = (await firebaseUtils?.getAnonymousID()) ?? ""
    Sentry.setUser({ id: u_id })
  }

  if (!import.meta.env.SSR) {
    Sentry.init({
      app,
      dsn: getSentryUrl(),
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      tracePropagationTargets: [],
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
    setSentryUid()
  }

  return {
    app,
    router,
    store,
    head,
  }
}
